'use strict';

module.exports = {
    /**
     * Change the state of the inputs or elements suplied
     * @param {Array} queryObj Is an array of objects with the next syntax
     * {
     *   query: the index of cachedSelector or element ID/class,
     *   actions: object key-value, with action and state. E.g.: {checked: true}
     * }
     */
    changeQueryState: function(queryObj) {
        var $el;
        var $cachedSelectors = this.$cachedSelectors || [];
        Odigeo._.each(queryObj, function(item) {
            $el = ($cachedSelectors[item.query] instanceof $) ? $cachedSelectors[item.query] : $(item.query);
            $el.each(function() {
                Odigeo._.each(item.actions, function(val, key) {
                    $(this).prop(key, val);
                }, this);
            });
        });
    },

    getParams: function(event) {
        return Odigeo._.isUndefined(event.currentTarget) ? event : $(event.currentTarget).data();
    },
};
